// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import VueResource from 'vue-resource'
import VueAuth from '@websanova/vue-auth'
import Vuelidate from 'vuelidate'
import Toasted from 'vue-toasted'
import BlockUI from 'vue-blockui'
import VueConstants from 'vue-constants'

import $ from 'jquery'
import i18n from './i18n'
window.$ = $;

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Toasted)
Vue.use(BlockUI)
Vue.use(VueResource)
Vue.use(VueConstants)
Vue.use(i18n)
Vue.router = router

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@/interceptors.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: { url: '/api/account/login', fetchUser: true },
  refreshData: { enabled: false },
  fetchData: { url: '/api/account/user', method: 'GET', enabled: true },
  authRedirect: { path: '/Pages/Login' },
  rolesVar: 'roles',
  parseUserData: function (res) {
    if (res.Data) {
      if (res.Data.User) {
        res.Data.User.roles = JSON.parse(localStorage.getItem('roles'));
        return res.Data.User;
      }
    }

    return {};
  }
})

Vue.mixin({
  data: function () {
    return {
      loading: false,
      blockuimsg: i18n.t('Loading')
    }
  },
  methods: {
    /**
     * @method actionLogout
     * @description Logout
     * */
    actionLogout: function () {
      localStorage.setItem('roles', null);
      this.$auth.logout({ redirect: '/pages/login' });
    },
    /*
     * @method openNewTabUrl
     * @description Abre un nueva tab con url
     * @param {string} urlName: Url name router
     */
    openNewTabUrl(urlName, params) {
      let url = '';
      if (params !== null && params !== undefined) {
        url = this.$router.resolve({ name: urlName, query: params }).href;
      } else {
        url = this.$router.resolve({ name: urlName }).href;
      }

      const win = window.open(url, '_blank');
      win.focus();
    },
    /**
     * @method redirectTo
     * @description Redirect url
     * @param {any} urlName
     * @param {any} params
     */
    redirectTo(urlName, params) {
      if (params !== null && params !== undefined) {
        this.$router.push({ name: urlName, query: params });
      } else {
        this.$router.push({ name: urlName });
      }
    },
    /**
     * @method getRolesAcceso
     * @description Obtiene los código interno de las visuales
     * a las que el usuario logueado tiene acceso
     */
    getRolesAccesos(rol_accesos, tipoUsuario) {
      const rolAccesos = [];

      rol_accesos.forEach(function (ra) {
        rolAccesos.push(ra.codigo_interno);
      });

      // Agrego él tipo de usuario, que vale como un rol para el router
      rolAccesos.push(tipoUsuario);

      return rolAccesos;
    }
    /**
     * @menu setMenu
     * @description Arma el menú
     */
  }
})

export const eventBus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  i18n,

  components: {
    App
  }
})
